import { Vue, Component } from "vue-property-decorator";
import { User } from "@/components/User";
import { ICodeList, IMapFilter } from "@/components/map/types";
import { isMobile, isNumeric, isEmptyObject, 
         parseValue, createDate } from "@/common/utils";
import Map from "@/components/map/Map";

const MAP_EXTENT: [number,number,number,number] = [95.854, 5.299, 106.064, 20.533];

@Component
export default class SearchBase extends Vue {
  $map: Map;
  filter: IMapFilter = {
    Source: "GISagro",
    Keyword: null,
    ProvinceCode: null,
    AmphoeCode: null,
    TambonCode: null,
    CropType: null,
    CropGenus: null,
    CropSpecies: null,
    DeedType: null,
    GrowOrHarvest: null,
    GrowOrHarvestYear: null,
    AreaType: null,
    Area1: {
      Rai: null,
      Ngan: null,
      SqWah: null
    },
    Area2: {
      Rai: null,
      Ngan: null,
      SqWah: null
    }
  };

  showOptions: boolean = true;
  searchResults: {[key:string] : any} = null;
  isSearching: boolean = false;
  
  showAdminAreaFilter:boolean = true;
  srhProvinces: ICodeList[] = [];
  srhAmphoes: ICodeList[] = [];
  srhTambons: ICodeList[] = [];
  isLoadingProvinces: boolean = false;
  isLoadingAmphoes: boolean = false;
  isLoadingTambons: boolean = false;

  showCropFilter:boolean = false;
  srhCropTypes: ICodeList[] = [];
  srhCropGenus: ICodeList[] = [];
  srhCropSpecies: ICodeList[] = [];
  isLoadingCropTypes: boolean = false;
  isLoadingCropGenus: boolean = false;
  isLoadingCropSpecies: boolean = false;

  showDeedTypeFilter:boolean = false;
  srhDeedTypes: ICodeList[] = [];
  isLoadingDeedTypes: boolean = false;

  showYearFilter: boolean = false;
  showLandAreaFilter: boolean = false;

  initialize(data) {
    this.fetchProvinces();
    this.fetchCropTypes();
    this.fetchDeedTypes();
    if (data) {
      this.$map = data.$map;
      //this.filter = data.filter;
      //CLONE the filter, instead
      for (let f in data.filter) {
        if (f=='Area1' || f=='Area2') {
          for (let a in data.filter[f]) {
            this.filter[f][a] = data.filter[f][a];
          }
        } else {
          this.filter[f] = data.filter[f];
        }
      }
      if (this.filter) {
        if (this.filter.ProvinceCode) {
          this.fetchAmphoes();
          if (this.filter.AmphoeCode) {
            this.fetchTambons();
          }
        }
        this.showAdminAreaFilter = !!this.filter.ProvinceCode || !!this.filter.AmphoeCode || !!this.filter.TambonCode;
        if (this.filter.CropType) {
          this.fetchCropGenus();
          if (this.filter.CropGenus) {
            this.fetchCropSpecies();
          }
        }
        this.showCropFilter = !!this.filter.CropType || !!this.filter.CropGenus || !!this.filter.CropSpecies;
        this.showDeedTypeFilter = !!this.filter.DeedType;
        this.showYearFilter = !!this.filter.GrowOrHarvest && !!this.filter.GrowOrHarvestYear;
        this.showLandAreaFilter = !!this.filter.AreaType;
        this.setFilter();
      }
    }
  }

  get language() : string {
    return this.$store.getters.Language;
  }

  get User() : User {
    return this.$store.getters.User;
  }

  get WindowWidth() : number {
    return this.$store.getters.WindowWidth;
  }

  get isSmallOrMobile() : boolean {
    return isMobile() || this.WindowWidth<600;
  }

  get PlaceHolderByDataSource() {
    return this.filter.Source=='GISagro' ? 'ใส่ชื่อ หรือ เลขประจำตัวฯ' : 'ใส่เลขที่โฉนด';
  }

  get BudgetYear() : number {
    let today = new Date();
    let yyyy = today.getFullYear();
    let beginOfBudgetYear = new Date(yyyy,9,1,0,0,0,0);
    if (today >= beginOfBudgetYear) {
      yyyy++;
    }
    return yyyy;
  }

  LandColor(land) : number {
    return (land.fssn_fk || land.farmer_ssn) ? 2 : 
            land.status ? 2 : 0;
  }

  get GrowHarvestYearList() {
    let years = [];
    let lang = this.language;
    let thisYear = (new Date()).getFullYear();
    let i;
    for (i=-8; i<2; i++) {
      if (lang=='th') {
        years.push(thisYear + i + 543);
      } else {
        years.push(thisYear + i);
      }
    }
    return years;
  }

  setFilter() {
    let showLandLayer:boolean = false;
    let filter:any = {};
    let i, crop:any = {}, area:any = {};
    if (this.filter.Source=='GISagro' && this.filter.TambonCode) {
      if (!this.autoFilter) this.zoomToTambon();
      filter.aag = 'aag5_fk=' + this.filter.TambonCode;
      for (i=0; i<this.srhTambons.length; i++) {
        if (this.srhTambons[i].code==this.filter.TambonCode) {
          area.tambon = (this.filter.ProvinceCode==10 ? 'แขวง' : 'ต.') + 
                        this.srhTambons[i].name;
          break;
        }
      }
    }
    if (this.filter.AmphoeCode) {
      if (!filter.aag) {
        if (!this.autoFilter) this.zoomToAmphoe();
        filter.aag = 'aag4_fk=' + this.filter.AmphoeCode;
      }
      for (i=0; i<this.srhAmphoes.length; i++) {
        if (this.srhAmphoes[i].code==this.filter.AmphoeCode) {
          area.amphoe = (this.filter.ProvinceCode==10 ? 'เขต' : 'อ.') + 
                         this.srhAmphoes[i].name;
          break;
        }
      }
    } 
    if (this.filter.ProvinceCode) {
      if (!filter.aag) {
        if (!this.autoFilter) this.zoomToProvince();
        filter.aag = 'aag3_fk=' + this.filter.ProvinceCode;
      }
      for (i=0; i<this.srhProvinces.length; i++) {
        if (this.srhProvinces[i].code==this.filter.ProvinceCode) {
          area.province = (this.filter.ProvinceCode==10 ? '' : 'จ.') + 
                           this.srhProvinces[i].name;
          break;
        }
      }
    }
    if (this.filter.Source=='GISagro') {
      if (this.filter.CropSpecies) {
        filter.crop = 'crop_fk=' + this.filter.CropSpecies;
        for (i=0; i<this.srhCropSpecies.length; i++) {
          if (this.srhCropSpecies[i].code==this.filter.CropSpecies) {
            crop.crop = this.srhCropSpecies[i].name;
            break;
          }
        }
        showLandLayer = true;
      }
      if (this.filter.CropGenus) {
        filter.crop = filter.crop || ('genus_fk=' + this.filter.CropGenus);
        for (i=0; i<this.srhCropGenus.length; i++) {
          if (this.srhCropGenus[i].code==this.filter.CropGenus) {
            crop.genus = this.srhCropGenus[i].name;
            break;
          }
        }
        showLandLayer = true;
      } 
      if (this.filter.CropType) {
        filter.crop = filter.crop || ('type_fk=' + this.filter.CropType);
        for (i=0; i<this.srhCropTypes.length; i++) {
          if (this.srhCropTypes[i].code==this.filter.CropType) {
            crop.type = this.srhCropTypes[i].name;
            break;
          }
        }
        showLandLayer = true;
      }
      if (this.filter.DeedType) {
        filter.deed = "deed_type='" + this.filter.DeedType + "'";
        showLandLayer = true;
      }
      if (this.filter.GrowOrHarvest && this.filter.GrowOrHarvestYear) {
        let year = this.filter.GrowOrHarvestYear;
        if (year>2500) year -= 543;
        filter.year = this.filter.GrowOrHarvest + '_yyyy=' + year;
      }
      if (this.filter.AreaType=='lte' || this.filter.AreaType=='gte') {
        if (!!this.filter.Area1.Rai || this.filter.Area1.Rai===0 ||
            !!this.filter.Area1.Ngan || this.filter.Area1.Ngan===0 ||
            !!this.filter.Area1.SqWah || this.filter.Area1.SqWah===0)  {
          let sqm = (this.filter.Area1.Rai || 0) * 1600 +
                    (this.filter.Area1.Ngan || 0) * 400 +
                    (this.filter.Area1.SqWah || 0) * 4;
          filter.area = 'area_sqm' + (this.filter.AreaType=='lte' ? '<=' : '>=') + sqm;
          showLandLayer = true;
        }
      } else if (this.filter.AreaType=='between' && 
        (!!this.filter.Area1.Rai || this.filter.Area1.Rai===0 ||
          !!this.filter.Area1.Ngan || this.filter.Area1.Ngan===0 ||
          !!this.filter.Area1.SqWah || this.filter.Area1.SqWah===0) && 
        (!!this.filter.Area2.Rai || this.filter.Area2.Rai===0 ||
          !!this.filter.Area2.Ngan || this.filter.Area2.Ngan===0 ||
          !!this.filter.Area2.SqWah || this.filter.Area2.SqWah===0)) {
        let sqm1 = (this.filter.Area1.Rai || 0) * 1600 +
                    (this.filter.Area1.Ngan || 0) * 400 +
                    (this.filter.Area1.SqWah || 0) * 4;
        let sqm2 = (this.filter.Area2.Rai || 0) * 1600 +
                    (this.filter.Area2.Ngan || 0) * 400 +
                    (this.filter.Area2.SqWah || 0) * 4;
        if (sqm1<sqm2) {
          filter.area = 'area_sqm BETWEEN ' + sqm1 + ' AND ' + sqm2;
          showLandLayer = true;
        } else if (sqm1>sqm2) {
          filter.area = 'area_sqm BETWEEN ' + sqm2 + ' AND ' + sqm1;
          showLandLayer = true;
        } else {
          filter.area = 'area_sqm=' + sqm1;
          showLandLayer = true;
        }
      }
    }
    if (isEmptyObject(filter)) {
      this.clearFilter();
    } else {
      this.$map.createFilter(filter);
      if (this.filter.Keyword) {
        this.doSearchLand();
      }
      if (showLandLayer) {
        this.$emit('iWantToDo', {
          name: 'show_farmland_layer'
        });
      }
      let text = '';
      if (area.tambon) {
        text = area.tambon + ' ' + area.amphoe + ' ' + area.province;
      } else if (area.amphoe) {
        text = area.amphoe + ' ' + area.province;
      } else if (area.province) {
        text = area.province;
      }
      this.filter.AreaText = text;
      text = '';
      if (crop.crop) {
        if (crop.type!=crop.genus) {
          text = crop.type + ' ชนิด' + crop.genus + ' พันธุ์' + crop.crop;
        } else {
          text = crop.genus + ' พันธุ์' + crop.crop;
        }
      } else if (crop.genus) {
        if (crop.type!=crop.genus) {
          text = crop.genus + ' พันธุ์' + crop.crop;
        } else {
          text = crop.genus;
        }
        text = crop.type + ' ชนิด' + crop.genus;
      } else if (crop.type) {
        text = crop.type
      }
      this.filter.CropText = text;
      this.$emit('iWantToDo', {
        name: 'change_map_filter',
        data: this.filter
      });
    }
  }

  clearFilter() {
    for (let p in this.filter) {
      if (p=='Source') {
        this.filter[p] = 'GISagro';
      } else if (p=='Area1' || p=='Area2') {
        this.filter[p] = {
          Rai: null,
          Ngan: null,
          SqWah: null
        }
      } else if (p!='Keyword') { //keep Keyword for search
        this.filter[p] = null;
      }
    }
    this.filter.CropText = null;
    this.filter.AreaText = null;
    this.showAdminAreaFilter = false;
    this.showCropFilter = false;
    this.showDeedTypeFilter = false;
    this.showYearFilter = false;
    this.showLandAreaFilter = false;
    
    this.$map.clearAoi();
    this.$map.clearFilter();
    this.$emit('iWantToDo', {
      name: 'change_map_filter',
      data: this.filter
    });
    this.$map.MapExtent = MAP_EXTENT;
    if (this.searchResults && this.searchResults.length>0) {
      this.clearSearchResults();
    }
  }

  async fetchProvinces() {
    try {
      this.isLoadingProvinces = true;
      let data = await this.User.requestResource('codelist/province');
      this.srhProvinces = data.map((d) => {
        return d;
      });
      this.isLoadingProvinces = false;
    } catch (error) {
      this.isLoadingProvinces = false;
    }
  };

  async fetchAmphoes() {
    try {
      this.srhAmphoes = [];
      this.srhTambons = [];
      if (!this.filter.ProvinceCode) {
        this.filter.AmphoeCode = null;
        this.filter.TambonCode = null;
      } else {
        if (this.filter.AmphoeCode && (
            this.filter.AmphoeCode+'').substr(0,2)!=(this.filter.ProvinceCode+'')) {
          this.filter.AmphoeCode = null;
          this.filter.TambonCode = null;
        }
        this.isLoadingAmphoes = true;
        let rest = 'codelist/amphoe/' + this.filter.ProvinceCode;
        let data = await this.User.requestResource(rest);
        this.srhAmphoes = data.map((d) => {
          return d;
        });
        this.isLoadingAmphoes = false;
      }
    } catch (error) {
      this.isLoadingAmphoes = false;
    }
  };

  async fetchTambons() {
    try {
      this.srhTambons = [];
      if (!this.filter.AmphoeCode) {
        this.filter.TambonCode = null;
      } else {
        if (this.filter.TambonCode && (
            this.filter.TambonCode+'').substr(0,4)!=(this.filter.AmphoeCode+'')) {
          this.filter.TambonCode = null;
        }
        this.isLoadingTambons = true;
        let rest = 'codelist/tambon/' + this.filter.AmphoeCode;
        let data = await this.User.requestResource(rest);
        this.srhTambons = data.map((d) => {
          return d;
        });
        this.isLoadingTambons = false;
      }
    } catch (error) {
      this.isLoadingTambons = false;
    }
  };
  
  autoFilter:boolean = false; //true for download in ./download.land.vue
  onProvinceChange() {
    if (this.autoFilter) this.zoomToProvince();
    this.fetchAmphoes();
  };

  onAmphoeChange() {
    if (this.autoFilter) this.zoomToAmphoe();
    this.fetchTambons();
  };

  onTambonChange() {
    if (this.autoFilter) this.zoomToTambon();
  };

  async zoomToProvince() {
    try {
      if (!this.filter.ProvinceCode) {
        this.filter.AmphoeCode = null;
        this.filter.TambonCode = null;
        this.$map.clearAoi();
        this.$map.MapExtent = MAP_EXTENT;
        if (this.autoFilter) this.setFilter();
      } else {
        let province:ICodeList;
        this.srhProvinces.forEach((p) => {
          if (p.code==this.filter.ProvinceCode) {
            province = p;
            return;
          }
        });
        if (this.autoFilter) this.setFilter();
        let zoomTo = true;
        let resetMapExtent = true;
        if (!province.feature) {
          let url;
          /*let bbox;
          try {
            url = 'gis/bbox/province/' + this.filter.ProvinceCode + '?crs=3857';
            bbox = await this.User.requestResource(url);
            //this.$map.changeMapView('zoomToExtent',{extent:[bbox.xmin,bbox.ymin,bbox.xmax,bbox.ymax]});
            //this.$map.MapExtent = [bbox.xmin,bbox.ymin,bbox.xmax,bbox.ymax];
          } catch (be) {
            bbox = null;
            resetMapExtent = false;
          }*/
          url = 'gis/province/' + this.filter.ProvinceCode + '?crs=3857';
          province.feature = await this.User.requestResource(url);
          province.feature = this.$map.GeoJSONToFeatures(province.feature);
          //zoomTo = !bbox;
          //this.$map.addFeaturesToLayer(province.feature, "AoiLayer", {
          //  zoomTo: !bbox
          //});
        //} else {
        //  this.$map.addFeaturesToLayer(province.feature, "AoiLayer");
        }
        this.$map.addFeaturesToLayer(province.feature, "AoiLayer");
      }
    } catch (error) {
      console.log(error);
    }
  };

  async zoomToAmphoe() {
    try {
      if (!this.filter.AmphoeCode) {
        this.filter.TambonCode = null;
        this.zoomToProvince();
      } else {
        let amphoe:ICodeList;
        this.srhAmphoes.forEach((a) => {
          if (a.code==this.filter.AmphoeCode) {
            amphoe = a;
            return;
          }
        });
        if (this.autoFilter) this.setFilter();
        if (!amphoe.feature) {
          let url;
          /*let bbox;
          try {
            url = 'gis/bbox/amphoe/' + this.filter.AmphoeCode + '?crs=3857';
            bbox = await this.User.requestResource(url);
            this.$map.MapExtent = [bbox.xmin,bbox.ymin,bbox.xmax,bbox.ymax];
          } catch (be) {
            bbox = null;
          }*/
          url = 'gis/amphoe/' + this.filter.AmphoeCode + '?crs=3857';
          amphoe.feature = await this.User.requestResource(url);
          amphoe.feature = this.$map.GeoJSONToFeatures(amphoe.feature);
          //this.$map.addFeaturesToLayer(amphoe.feature, "AoiLayer", {
          //  zoomTo: !bbox
          //});
        //} else {
        //  this.$map.addFeaturesToLayer(amphoe.feature, "AoiLayer");
        }
        this.$map.addFeaturesToLayer(amphoe.feature, "AoiLayer");
      }
    } catch (error) {
    }
  };

  async zoomToTambon() {
    try {
      if (!this.filter.TambonCode) {
        this.zoomToAmphoe();
      } else {
        let tambon:ICodeList;
        this.srhTambons.forEach((t) => {
          if (t.code==this.filter.TambonCode) {
            tambon = t;
            return;
          }
        });
        if (this.autoFilter) this.setFilter();
        if (!tambon.feature) {
          let rsc = 'gis/tambon/' + this.filter.TambonCode + '?crs=3857';
          tambon.feature = await this.User.requestResource(rsc);
          tambon.feature = this.$map.GeoJSONToFeatures(tambon.feature);
        }
        this.$map.addFeaturesToLayer(tambon.feature, "AoiLayer");
      }
    } catch (error) {
    }
  };

  clearSelectedFilter(aoiVariableName:string) {
    if (aoiVariableName) {
      this.filter[aoiVariableName] = null;
    } else {
      this.filter.ProvinceCode = null;
    }
  };

  onCropTypeChange() {
    this.fetchCropGenus();
    if (this.autoFilter) this.setFilter();
  };

  onCropGenusChange() {
    this.fetchCropSpecies();
    if (this.autoFilter) this.setFilter();
  };

  onCropSpeciesChange() {
    if (this.autoFilter) this.setFilter();
  }

  onDeedTypeChange() {
    if (this.autoFilter) this.setFilter();
  }

  onGrowHarvestYearChange() {
    if (this.autoFilter) this.setFilter();
  }

  async fetchCropTypes() {
    try {
      this.isLoadingCropTypes = true;
      let data = await this.User.requestResource('codelist/crop_types');
      this.srhCropTypes = data.map((d) => {
        return d;
      });
      this.isLoadingCropTypes = false;
    } catch (error) {
      this.isLoadingCropTypes = false;
    }
  };

  async fetchCropGenus() {
    try {
      this.srhCropGenus = [];
      this.srhCropSpecies = [];
      if (!this.filter.CropType) {
        this.filter.CropType = null;
      } else {
        this.isLoadingCropGenus = true;
        let rest = 'codelist/crop_genera/' + this.filter.CropType;
        let data = await this.User.requestResource(rest);
        this.srhCropGenus = data.map((d) => {
          return d;
        });
        this.isLoadingCropGenus = false;
      }
    } catch (error) {
      this.isLoadingCropGenus = false;
    }
  };

  async fetchCropSpecies() {
    try {
      this.srhCropSpecies = [];
      if (!this.filter.CropGenus) {
        this.filter.CropSpecies = null;
      } else {
        this.isLoadingCropSpecies = true;
        let rest = 'codelist/crop_species/' + this.filter.CropGenus;
        let data = await this.User.requestResource(rest);
        this.srhCropSpecies = data.map((d) => {
          return d;
        });
        if (this.srhCropSpecies.length==1) {
          this.filter.CropSpecies = <number>this.srhCropSpecies[0].code;
        }
        this.isLoadingCropSpecies = false;
      }
    } catch (error) {
      this.isLoadingCropSpecies = false;
    }
  };

  async fetchDeedTypes() {
    try {
      this.isLoadingDeedTypes = true;
      let data = await this.User.requestResource('codelist/deed_types');
      this.srhDeedTypes = data.map((d) => {
        return d;
      });
      this.isLoadingDeedTypes = false;
    } catch (error) {
      this.isLoadingDeedTypes = false;
    }
  }
  
  doSearchLand() {
    if (!this.filter.Keyword) {
      return;
    }
    this.$map.clearLayer('SearchFeatureLayer');
    this.$map.clearLayer('SelectedFeatureLayer');
    this.$map.hideInfoPopup();
    this.searchResults = null;
    let errMsg:string[];
    let couldBeADeedNo = isNumeric(this.filter.Keyword);
    if (this.filter.Source=='DOL') {
      if (!this.filter.ProvinceCode) {
        errMsg = ['please','select','province','and','county'];
      } else if (!this.filter.AmphoeCode) {
        errMsg = ['please','select','county'];
      }
      if (errMsg) {
        this.alertError(errMsg);
        return;
      }
      this.doSearchLandFromDOL();
    } else if (this.filter.Source=='GISagro') {
      this.doSearchLandFromGISagro();
    } else {
      this.doSearchPlace();
    }
  };

  async doSearchLandFromDOL() {
    // also is override in search.land.vue
    try {
      this.isSearching = true;
      let params:any = {
        pv_id: this.filter.ProvinceCode,
        amp_id: this.filter.AmphoeCode,
        chanode: this.filter.Keyword,
        organization: 'GISAGRO'
      }
      let data = await this.User.requestResource('proxy/dol','POST',params);
      let land:any = {
        geometry: null,
        properties: {},
        type: 'Feature'
      };
      let mapping = require("../../../public/static/js/schemas").dol_mapping;
      for (let p in data) {
        switch (p.toLowerCase()) {
        case 'geojson':
          land.geometry = Object.assign({},data[p]);
          break;
        default: 
          let v = data[p];
          p = p.toLowerCase();
          if (mapping.hasOwnProperty(p)) {
            land.properties[mapping[p].name] = parseValue(v,mapping[p].dataType);
          } else {
            land.properties[p] = v;
          }
          break;
        }
      }
      land = this.$map.GeoJSONToFeatures(land, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:3857'
      });
      this.$map.addFeaturesToLayer(land, "SearchFeatureLayer", {
        resetMapExtent: false
      });
      land = land[0];
      let prop = land.getProperties();
      let an3, an4, an5;
      if (prop.aag3_fk==10) {
        an3 = prop.province;
        an4 = 'เขต' + prop.amphoe;
        an5 = 'แขวง' + prop.tambon;
      } else {
        an3 = 'จังหวัด' + prop.province;
        an4 = 'อำเภอ' + prop.amphoe;
        an5 = 'ตำบล' + prop.tambon;
      }
      let area = '';
      if (prop.deed_rai) {
        area = prop.deed_rai + ' ไร่';
      }
      if (prop.deed_ngan || prop.deed_sqwah) {
        area += ' ' + prop.deed_ngan + ' งาน';
      }
      if (prop.deed_sqwah) {
        area += ' ' + prop.deed_sqwah + ' ตารางวา';
      }
      area = area.trim();
      let self = this;
      let info:any = {
        title: 'ที่ดิน',
        info: 'ใน' + an5 + ' ' + an4 + ' ' + an3 + ' เนื้อที่ ' + area,
        popup: {
          style: "width:300px",
          position: this.$map.getFeatureCentroid(land).map,
          offset: [0,-20],
          onClose: () => {
            self.$map.clearLayer('SearchFeatureLayer');
          }
        },
        feature: land
      }
      setTimeout(() => {
        this.$map.showInfoPopup(info.title, info.info, info.popup);
      }, 250);
      this.searchResults = [{
      name: prop.office_name,
      results: [{
          status: 0,
          title: 'ตำแหน่งที่ดิน',
          subTitle: prop.tambon + ' ' + prop.amphoe + ' ' + prop.province,
          info: info
        },{
          status: 'na',
          title: 'เลขที่โฉนด',
          subTitle: '(' + prop.aac4_fk + ')' + prop.deed_no_g
        },{
          status: 'na',
          title: 'เลขที่ที่ดิน',
          subTitle: prop.parcel_no
        },{
          status: 'na',
          title: 'ประเภทที่ดิน',
          subTitle: prop.deed_type_g
        },{
          status: 'na',
          title: 'เนื้อที่ (ไร่-งาน-ตร.ว.)',
          subTitle: prop.deed_rai + '-' + prop.deed_ngan + '-' + prop.deed_sqwah
        }]
      }];
      this.isSearching = false;
    } catch(error) {
      this.isSearching = false;
      this.searchResults = [{
        name: 'ไม่พบข้อมูลที่ต้องการ'
      }];
    }
  }

  addDolLandToGISagro() {
    // should be override in search.land.vue
  }

  okToUpdateLandLayer:boolean = false;
  async doSearchLandFromGISagro() {
    try {
      let i;
      let okToSearch:boolean = false;
      let params:any = {
        uid: this.User.HalloId || 0,
        crs: 3857
      };
      let kword = this.filter.Keyword;
      if (!!kword) {
        okToSearch = true;
        if (isNumeric(kword) && kword.length<10) {
          params.gid = parseInt(kword);
        } else {
          params.keyword = kword;
        }
      }
      if (this.filter.ProvinceCode) {
        this.okToUpdateLandLayer = true;
        params.aag = this.filter.TambonCode || this.filter.AmphoeCode || this.filter.ProvinceCode;
      }
      if (this.filter.CropSpecies) {
        this.okToUpdateLandLayer = true;
        params.crop_species = this.filter.CropSpecies;
      } else if (this.filter.CropGenus) {
        this.okToUpdateLandLayer = true;
        params.crop_genus = this.filter.CropGenus;
      } else if (this.filter.CropType) {
        this.okToUpdateLandLayer = true;
        params.crop_type = this.filter.CropType;
      }
      if (this.filter.DeedType) {
        for (i=0; i<this.srhDeedTypes.length; i++) {
          if (this.srhDeedTypes[i].code==this.filter.DeedType) {
            params.deed = this.srhDeedTypes[i].name;
            this.okToUpdateLandLayer = true;
            break;
          }
        }
      }
      if (this.filter.GrowOrHarvest && this.filter.GrowOrHarvestYear) {
        this.okToUpdateLandLayer = true;
        let year = this.filter.GrowOrHarvestYear;
        if (year>2500) year -= 543;
        params[this.filter.GrowOrHarvest + '_year'] = year;
      }
      if (this.filter.AreaType) {
        this.okToUpdateLandLayer = true;
        if (this.filter.Area1.Rai || this.filter.Area1.Rai==0) {
          params.rai1 = this.filter.Area1.Rai;
          params.area_op = this.filter.AreaType;
        }
        if (this.filter.Area1.Ngan || this.filter.Area1.Ngan==0) {
          params.ngan1 = this.filter.Area1.Ngan;
          params.area_op = this.filter.AreaType;
        }
        if (this.filter.Area1.SqWah || this.filter.Area1.SqWah==0) {
          params.sqwah1 = this.filter.Area1.SqWah;
          params.area_op = this.filter.AreaType;
        }
        if (this.filter.AreaType=='between') {
          if (this.filter.Area2.Rai || this.filter.Area2.Rai==0) {
            params.rai2 = this.filter.Area2.Rai;
          }
          if (this.filter.Area2.Ngan || this.filter.Area2.Ngan==0) {
            params.ngan2 = this.filter.Area2.Ngan;
          }
          if (this.filter.Area2.SqWah || this.filter.Area2.SqWah==0) {
            params.sqwah2 = this.filter.Area2.SqWah;
          }
        }
      }
      if (this.okToUpdateLandLayer) {

      }
      if (okToSearch) {
        this.isSearching = true;
        let data = await this.User.requestResource('gis/farmland_search','GET',params);
        let land;
        land = this.$map.GeoJSONToFeatures(data);
        this.$map.addFeaturesToLayer(land, "SelectedFeatureLayer", {
          resetMapExtent: false
        });
        let key, prop, farmer, crop, info:any; 
        let an3, an4, an5;
        let result:any = {};
        let lang = this.language;
        for (i=0; i<land.length; i++) {
          prop = land[i].getProperties();
          key = prop.aag5_fk + '';
          if (prop.aag3_fk==10) {
            an3 = prop.province;
            an4 = 'เขต' + prop.amphoe;
            an5 = 'แขวง' + prop.tambon;
          } else {
            an3 = 'จ.' + prop.province;
            an4 = 'อ.' + prop.amphoe;
            an5 = 'ต.' + prop.tambon;
          }
          let area = '';
          if (prop.area_rai) {
            area = prop.area_rai + ' ไร่';
          }
          if (prop.area_ngan || prop.area_sqwah) {
            area += ' ' + prop.area_ngan + ' งาน';
          }
          if (prop.area_sqwah) {
            area += ' ' + prop.area_sqwah + ' ตารางวา';
          }
          area = area.trim();
          info = 'ใน' + an5 + ' ' + an4 + ' ' + an3 + ' เนื้อที่ ' + area;
          if (prop.type_th) {
            crop  = ' ปลูก' + prop['type_' + lang];
            crop += ' ชนิด' + prop['genus_' + lang];
            crop += ' พันธุ์' + prop['crop_' + lang];
          } else {
            crop = '';
          }
          info += crop;
          if (prop.name_th) {
            farmer = prop['title_' + lang] + prop['name_' + lang] + ' ' + prop['surname_' + lang];
            info += ' โดย' + farmer;
          } else if (prop.fssn_fk) {
            farmer = 'ไม่มีชื่อเกษตรกร';
          } else if (!prop.status || prop.status<1) {
            farmer = 'ยังไม่ได้ขึ้นทะเบียน';
          } else {
            farmer = 'ไม่เห็นข้อมูลเกษตรกร';
          }
          let self = this;
          result[key] = result[key] || {
            name: an5 + ' ' + an4 + ' ' + an3,
            results: []
          };
          result[key].results.push({
            status: this.LandColor(prop),
            title: farmer,
            subTitle: 'เนื้อที่ ' + area + (crop ? (' ' + crop) : ''),
            info: {
              title: 'แปลงปลูก',
              info: info,
              popup: {
                style: 'width:300px',
                position: this.$map.getFeatureCentroid(land[i]).map,
                offset: [0,-20],
                onClose: () => {
                  self.$map.clearLayer('SelectedFeatureLayer');
                }
              },
              feature: land[i]
            }
          });
        }
        this.searchResults = [];
        for (let r in result) {
          this.searchResults.push(result[r]);
        }
        if (this.searchResults.length==1) {
          info = this.searchResults[0].results[0].info;
          setTimeout(() => {
            this.$map.showInfoPopup(info.title, info.info, info.popup);
          }, 250);
        }
        this.isSearching = false;
      }
    } catch(error) {
      this.isSearching = false;
      this.searchResults = [{
        name: 'ไม่พบข้อมูลที่ต้องการ'
      }];
    }
  }

  async doSearchPlace() {
    try {
    } catch (error) {
      this.isSearching = false;
      this.searchResults = [{
        name: 'ไม่พบข้อมูลที่ต้องการ'
      }];
    }
  }

  zoomToResult(result) {
    let info = result.info;
    this.$map.addFeaturesToLayer([info.feature], 
      this.filter.Source.match(/DOL|PLACE/) ? 'SearchFeatureLayer' : 'SelectedFeatureLayer', {
      resetMapExtent: false
    });
    this.$map.showInfoPopup(info.title, info.info, info.popup);
  }

  clearSearchResults() {
    this.filter.Keyword = null;
    this.isSearching = false;
    this.isLoadingProvinces = false;
    this.isLoadingAmphoes = false;
    this.isLoadingTambons = false;
    this.isLoadingCropTypes = false;
    this.isLoadingCropGenus = false;
    this.isLoadingCropSpecies = false;
    this.isLoadingDeedTypes = false;
    this.$map.clearLayer('SearchFeatureLayer');
    this.$map.clearLayer('SelectedFeatureLayer');
    this.$map.hideInfoPopup();
    this.searchResults = null;
  }
  
  closeMe(me:string) {
    this.$emit('iWantToDo', {
      name: 'toggle_toc',
      data: me
    });
  }
  
  alertError(error:string | string[]) {
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: 'error',
        Title: 'error',
        Message: error,
        OkText: null,
        CancelText: 'close',
        show: true,
        OnClose: null
      }
    });
  }
}